module.exports = __webpack_public_path__ + "img/appAsset-brand--twocheckout.d53ffb1c.svg";